import { render, staticRenderFns } from "./assessCustommModu.vue?vue&type=template&id=0d77377f&scoped=true&"
import script from "./assessCustommModu.vue?vue&type=script&lang=js&"
export * from "./assessCustommModu.vue?vue&type=script&lang=js&"
import style0 from "./assessCustommModu.vue?vue&type=style&index=0&id=0d77377f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d77377f",
  null
  
)

export default component.exports